import { slice } from 'lodash';

import { cn } from '@lyearn/style';
import { Stack, Tooltip, Typography } from '@lyearn/ui';

import { FilterLabelWithOperatorProps } from './types';

const FilterLabelWithOperator: React.FC<FilterLabelWithOperatorProps> = (props) => {
  const { className, entityLabel, operator, value } = props;

  return (
    <Stack alignItems="center" className={cn('truncate', className)}>
      <Typography variant="body-short-02">{entityLabel}</Typography>
      <Typography className="mx-4" variant="body-short-02">
        {operator.label}
      </Typography>
      <Typography className="truncate" variant="label-02">
        {value?.[0]}
      </Typography>
      {value && value.length > 1 ? (
        <Tooltip placement="top" title={slice(value, 1).join(', ')}>
          <Typography variant="label-02">&nbsp;+{value.length - 1}</Typography>
        </Tooltip>
      ) : null}
    </Stack>
  );
};

export default FilterLabelWithOperator;
